import useMediaQuery  from '@mui/material/useMediaQuery';

const useTabletSize = () => {
    const size = useMediaQuery('(max-width: 1030px)');
    return size;
}
export default useTabletSize;